'use client';
export { AspectRatio } from '@radix-ui/react-aspect-ratio';
//# sourceMappingURL=aspect-ratio.js.map